import { render, staticRenderFns } from "./MobileQuotationModal.vue?vue&type=template&id=52472082&scoped=true&"
import script from "./MobileQuotationModal.vue?vue&type=script&lang=js&"
export * from "./MobileQuotationModal.vue?vue&type=script&lang=js&"
import style0 from "./MobileQuotationModal.vue?vue&type=style&index=0&id=52472082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52472082",
  null
  
)

export default component.exports